import { initializeApp } from "firebase/app";
import { initializeFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { getFunctions } from "firebase/functions";

const firebaseConfig = {
  apiKey: "AIzaSyCgkaVjjQ81EeMacb1kX1Uk2bmhK3uQpbE",
  authDomain: "chronologicle.firebaseapp.com",
  projectId: "chronologicle",
  storageBucket: "chronologicle.firebasestorage.app",
  messagingSenderId: "565458653324",
  appId: "1:565458653324:web:e55d9d63f96541eaf92ba9",
  measurementId: "G-XZ9VQ4QTVE" // this is required for analytics
};

const app = initializeApp(firebaseConfig);

// ✅ Disable persistence cache mode (important for local dev)
export const db = initializeFirestore(app, {
  localCache: "none"
});

export const auth = getAuth(app);
export const functions = getFunctions(app);
